function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var Divider = function Divider(props) {
  var className = props.className,
      additionalProps = _objectWithoutProperties(props, ["className"]);

  var dividerClass = classNames(className, 'd-block', 'bb', 'bc-grey-10', 'flex-1');
  return React.createElement("div", {
    className: "pos-r"
  }, !props.text && React.createElement("div", _extends({
    className: dividerClass
  }, additionalProps)), props.text && React.createElement("div", _extends({
    className: "flex flex-between flex-middle"
  }, additionalProps), React.createElement("div", {
    className: dividerClass
  }), React.createElement("p", {
    className: "px-5 fs-caption-2 c-grey-40"
  }, props.text), React.createElement("div", {
    className: dividerClass
  })));
};

Divider.propTypes = {
  /**
   * Class to be appended to the wrapping object
   */
  className: PropTypes.string,

  /**
   * Optional text to be shown on the divider
   */
  text: PropTypes.string
};
Divider.defaultProps = {
  className: '',
  text: ''
};
Divider.displayName = "Divider";
export { Divider };